export default __webpack_public_path__ + "static/media/02.a80e9e0c.png";